<template>
	<div>
		<AppDropdownMenu
			right
			bottom
			absolute
			rounded="lg"
			v-bind="$attrs"
			min-width="230"
			v-on="$listeners"
			:nudge-bottom="10"
			:items="menuItems"
		>
			<template #activator>
				<AnemicButton @click="(e) => e.preventDefault()" width="22" height="22" icon fab x-small class="flex-centerize menu-button mr-2">
					<SIcon name="project-menu-three-dots" class="menu-icon" :width="2" :height="13" />
				</AnemicButton>
			</template>
		</AppDropdownMenu>
	</div>
</template>

<script>
import AppDialogManagerService from '@/components/dialogs/AppDialogManager/app-dialog-manager-service';
export default {
	name: 'ProjectMenuSettingsDropdown',
	components: {},
	props: {
		project: { type: Object },
	},
	computed: {},
	methods: {
		openSettings() {
			AppDialogManagerService.openProjectSettingsDialog({ project: this.project });
		},
	},
	data() {
		return {
			menuItems: [{ text: 'Space settings', onClick: this.openSettings }],
		};
	},
};
</script>

<style scoped lang="scss">
.menu-button {
	background: transparent !important;
	.menu-icon {
		margin-top: 1px;
		margin-left: -4px;
	}
	&:hover {
		border: 1px solid var(--forth-border-color);
	}
}
</style>
